<div class="gallery-container gc-1">
  <!-- Dynamic property images carousel in mobile view -->
  <div class="gallery-images-section">
    <!-- <h2>The Greenstar Inn Premium Gallery <br>(Near Sum Hospital , Bhubaneswar)</h2> -->
    <h2 style="color: #000;" class="features-heading">VISIT GALLERY<br>
      <span class="sub-head-span" style="color: #379237">The Greenstar Premium (Near Sum Hospital)</span></h2>

    <!-- Carousel view for mobile devices -->
    <ngx-slick-carousel class="gallery-carousel" *ngIf="isMobileView" [config]="slideConfig">
      <div ngxSlickItem *ngFor="let image of property?.imageList" class="gallery-image-card">
        <img [src]="image.url" alt="Property Image">
      </div>
    </ngx-slick-carousel>

    <div class="gallery-image-grid">
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img24.jpeg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/greenstarinnpremium.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/grnstar-premium1.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/grnstar-premium2.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/grnstar-premium3.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/grnstar-premium4.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/grnstar-premium7.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/grnstar-premium8.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img38.jpeg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img26.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img10.jpeg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img20.jpeg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img17.jpeg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img19.jpeg">
      </div>
    </div>
  </div>
</div>

<div class="gallery-container gc-1">
  <!-- Dynamic property images carousel in mobile view -->
  <div class="gallery-images-section">
    <!-- <h2>The Greenstar Inn Gallery <br>(Near Biju Pattanaik Airport , Bhubaneswar)</h2> -->
    <h2 style="color: #000;" class="features-heading">VISIT GALLERY<br>
      <span class="sub-head-span" style="color: #379237">The Greenstar (Near Biju Pattanaik Airport)</span></h2>

    <!-- Carousel view for mobile devices -->
    <ngx-slick-carousel class="gallery-carousel" *ngIf="isMobileView" [config]="slideConfig">
      <div ngxSlickItem *ngFor="let image of property?.imageList" class="gallery-image-card">
        <img [src]="image.url" alt="Property Image">
      </div>
    </ngx-slick-carousel>

    <div class="gallery-image-grid">
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img45.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/greenstarinn.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img35.jpeg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img33.jpeg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img2.jpeg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img31.jpeg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img43.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img37.jpeg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img44.jpg">
      </div>
  </div>
</div>
